import { SearchExportReportsRequest, truktApi } from '@api';
import { useQuery } from '@tanstack/react-query';
import { QUERY_CACHE_IDS_MAP } from '@types';

import { UseSearchExportedReportsQueryOptions } from './useSearchExportedReportsQuery.types';

export const useSearchExportedReportsQuery = (
  request: SearchExportReportsRequest,
  options?: UseSearchExportedReportsQueryOptions,
) => {
  const queryKey = [QUERY_CACHE_IDS_MAP.REPORTS, request];
  const query = useQuery({
    ...options,
    queryKey: queryKey,

    queryFn: async () => {
      const { data } = await truktApi.report.exports.search(request);
      return data;
    },
  });

  return { query, queryKey };
};
